import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useState } from 'react';
import { getHebrewYear } from '../../../../../../utils/hebrew-date-utils';
import globalSettingsBranches from '../../../../../../stores/global-settings-branches';
import { toast } from 'react-toastify';
import { WarningDialog } from '../../../../../../component/ui/warning-dialog/warning-dialog';

interface CreateProgramDatamodel {
  loading: boolean;
  approve: (startYear: number, branchId: number) => any;
  programName?: string;
}

export const CreateProgram: React.FC<CreateProgramDatamodel> = ({
  loading,
  approve,
  programName,
}) => {
  const [workingYear, setWorkingYear] = useState<number | null>(null);
  const [selectedBranchId, setSelectedBranchId] = useState<number | null>(null);
  const [showWarningDialog, setShowWarningDialog] = useState(false);

  const availableWorkingYears =
    globalSettingsBranches.workingTimeManagement.availableWorkingYears;

  const years = availableWorkingYears.map((item) => ({
    year: `${getHebrewYear(item)} (${item} - ${item + 1})`,
    code: 'year',
    value: item,
  }));

  const branches = globalSettingsBranches.branches.map((branch) => ({
    label: branch.branchName,
    value: branch.id,
  }));

  const handleApprove = () => {
    if (!workingYear) {
      toast.warn('יש לבחור שנת התחלה לתוכנית');
      return;
    }

    if (!selectedBranchId) {
      toast.warn('יש לבחור שלוחה');
      return;
    }

    setShowWarningDialog(true);
  };

  const handleConfirmApprove = () => {
    if (workingYear && selectedBranchId) {
      approve(workingYear, selectedBranchId);
      setShowWarningDialog(false);
    }
  };

  const selectedBranch = globalSettingsBranches.branches.find(
    (branch) => branch.id === selectedBranchId,
  );
  const selectedYear = years.find((year) => year.value === workingYear);

  return (
    <div>
      <label>שלוחה</label>

      <Dropdown
        value={selectedBranchId}
        options={branches}
        style={{ width: '100%', marginTop: '8px', marginBottom: '16px' }}
        onChange={(e) => setSelectedBranchId(e.value)}
        optionLabel="label"
        placeholder="בחר שלוחה"
        dir="rtl"
        panelStyle={{ maxWidth: '200px' }}
      />

      <label>שנת התחלה</label>

      <Dropdown
        value={workingYear}
        options={years}
        style={{ width: '100%', marginTop: '8px', marginBottom: '16px' }}
        onChange={(e) => setWorkingYear(e.value)}
        optionLabel="year"
        placeholder="בחר שנת התחלה"
        dir="rtl" // Add this line for RTL support
        panelStyle={{ maxWidth: '200px' }}
      />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{ height: '30px' }}
          label={'אישור'}
          loading={loading}
          disabled={!workingYear || !selectedBranchId}
          tooltip={
            !workingYear || !selectedBranchId
              ? 'יש לבחור שלוחה ושנת התחלה'
              : 'לחץ ליצירת תוכנית'
          }
          tooltipOptions={{ showOnDisabled: true }}
          onClick={handleApprove}
        />
      </div>

      <WarningDialog
        header="אישור יצירת תוכנית"
        isVisible={showWarningDialog}
        onHide={() => setShowWarningDialog(false)}
        addIcon={true}
        content={`הינך עומד ליצור את התוכנית ${programName || ''} בשנה ${selectedYear?.year || ''} עם השלוחה ${selectedBranch?.branchName || ''}`}
        dangerousContent="יש לוודא את השלוחה המבוקשת והשנה אליה הינך פותח את התוכנית"
        notInformation={
          'לאחר האישור ניתן יהיה לצפות בפרטי התוכנית בדוח תוכניות'
        }
        onConfirm={handleConfirmApprove}
        confirmLabel="אישור"
        confirmLoading={loading}
        cancelLabel="ביטול"
      />
    </div>
  );
};
